import { uniq } from "lodash";
import {
  FACEBOOK_PAGE,
  INSTAGRAM_BUSINESS,
  LINKEDIN_COMPANY,
  TWITTER_PROFILE,
} from "./SocialType";

// Facebook Metrics

export const ENGAGED_USERS = {
  id: "engaged_users",
  label: "Engaged Users",
  color: "#85de55",
  areaColors: [
    { offset: 0, color: "rgba(133, 222, 85, 0.2)" },
    { offset: 80, color: "rgba(133, 222, 85, 0)" },
  ],
};

export const POST_IMPRESSION = {
  id: "post_impression",
  label: "Post Impressions",
  color: "#ff4a98",
  areaColors: [
    { offset: 0, color: "rgba(255, 74, 152, 0.2)" },
    { offset: 80, color: "rgba(255, 74, 152, 0)" },
  ],
};

export const POST_REACH = {
  id: "post_reach",
  label: "Post Reach",
  color: "#ff6982",
  areaColors: [
    { offset: 0, color: "rgba(255, 105, 130, 0.2)" },
    { offset: 50, color: "rgba(255, 105, 130, 0)" },
  ],
};

export const PAGE_POST_ENGAGEMENTS = {
  id: "page_post_engagements",
  label: "Page Post Engagements",
  color: "#7b50ff",
  areaColors: [
    { offset: 0, color: "rgba(123, 80, 255, 0.2)" },
    { offset: 80, color: "rgba(123, 80, 255, 0)" },
  ],
};

export const NEW_FAN = {
  id: "new_fan",
  label: "New Fans",
  color: "#FFE086",
  areaColors: [
    { offset: 0, color: "rgba(104, 213, 255, 0.2)" },
    { offset: 80, color: "rgba(104, 213, 255, 0)" },
  ],
};

export const REACTIONS = {
  id: "reactions",
  label: "Reactions",
  color: "#008cd3",
  areaColors: [
    { offset: 0, color: "rgba(0, 140, 211, 0.2)" },
    { offset: 80, color: "rgba(0, 140, 211, 0)" },
  ],
};

export const TOTAL_FANS = {
  id: "total_fans",
  label: "Total Fans",
  color: "#009ba9",
  areaColors: [
    { offset: 0, color: "rgba(0, 155, 169, 0.2)" },
    { offset: 80, color: "rgba(0, 155, 169, 0)" },
  ],
};

export const LINK_CLICKS = {
  id: "link_clicks",
  label: "Link Clicks",
  color: "#69d5ff",
  areaColors: [
    { offset: 0, color: "rgba(105, 213, 255, 0.2)" },
    { offset: 80, color: "rgba(105, 213, 255, 0)" },
  ],
};

export const OTHER_CLICKS = {
  id: "other_clicks",
  label: "Other Clicks",
  color: "#d002ff",
  areaColors: [
    { offset: 0, color: "rgba(208, 2, 255, 0.2)" },
    { offset: 80, color: "rgba(208, 2, 255, 0)" },
  ],
};

export const PHOTO_VIEW = {
  id: "photo_view",
  label: "Photo Views",
  color: "#ff5e02",
  areaColors: [
    { offset: 0, color: "rgba(255, 94, 2, 0.2)" },
    { offset: 80, color: "rgba(255, 94, 2, 0)" },
  ],
};

export const VIDEO_PLAY = {
  id: "video_play",
  label: "Video Plays",
  color: "#f10404",
  areaColors: [
    { offset: 0, color: "rgba(244, 4, 4, 0.2)" },
    { offset: 80, color: "rgba(244, 4, 4, 0)" },
  ],
};

export const POSTS_COUNT = {
  id: "posts_count",
  label: "Posts Count",
  color: "#ffad02",
  areaColors: [
    { offset: 0, color: "rgba(255, 173, 2, 0.2)" },
    { offset: 80, color: "rgba(255, 173, 2, 0)" },
  ],
};

// Instagram Metrics

export const FOLLOWER_COUNT = {
  id: "follower_count",
  label: "Followers Count",
  color: "#FFE086",
  areaColors: [
    { offset: 0, color: "rgba(104, 213, 255, 0.2)" },
    { offset: 80, color: "rgba(104, 213, 255, 0)" },
  ],
};

export const IMPRESSIONS = {
  id: "impressions",
  label: "Impressions",
  color: "#ff4a98",
  areaColors: [
    { offset: 0, color: "rgba(255, 74, 152, 0.2)" },
    { offset: 80, color: "rgba(255, 74, 152, 0)" },
  ],
};

export const PROFILE_VIEWS = {
  id: "profile_views",
  label: "Profile Views",
  color: "#85de55",
  areaColors: [
    { offset: 0, color: "rgba(133, 222, 85, 0.2)" },
    { offset: 80, color: "rgba(133, 222, 85, 0)" },
  ],
};

export const TEXT_MESSAGE_CLICKS = {
  id: "text_message_clicks",
  label: "Text Message Clicks",
  color: "#d002ff",
  areaColors: [
    { offset: 0, color: "rgba(208, 2, 255, 0.2)" },
    { offset: 80, color: "rgba(208, 2, 255, 0)" },
  ],
};

export const WEBSITE_CLICKS = {
  id: "website_clicks",
  label: "Website Clicks",
  color: "#69d5ff",
  areaColors: [
    { offset: 0, color: "rgba(105, 213, 255, 0.2)" },
    { offset: 80, color: "rgba(105, 213, 255, 0)" },
  ],
};

export const EMAIL_CONTACTS = {
  id: "email_contacts",
  label: "Email Contacts",
  color: "#ff5e02",
  areaColors: [
    { offset: 0, color: "rgba(255, 94, 2, 0.2)" },
    { offset: 80, color: "rgba(255, 94, 2, 0)" },
  ],
};

export const REACH = {
  id: "reach",
  label: "Reach",
  color: "#fffbbd",
  areaColors: [
    { offset: 0, color: "rgba(255, 251, 189, 0.2)" },
    { offset: 80, color: "rgba(255, 251, 189, 0)" },
  ],
};

// Twitter Metrics

export const RETWEET_COUNT = {
  id: "retweetCount",
  label: "Retweets",
  color: "#fffbbd",
  static: true, // metric doesn't come with date range data from backend, so no chart is applicable;
  areaColors: [
    { offset: 0, color: "rgba(255, 251, 189, 0.2)" },
    { offset: 80, color: "rgba(255, 251, 189, 0)" },
  ],
};

export const LIKES_COUNT = {
  id: "likeCount",
  label: "Likes",
  color: "#fffbbd",
  areaColors: [
    { offset: 0, color: "rgba(255, 251, 189, 0.2)" },
    { offset: 80, color: "rgba(255, 251, 189, 0)" },
  ],
};

export const QUOTE_COUNT = {
  id: "quoteCount",
  label: "Quotes",
  color: "#fffbbd",
  areaColors: [
    { offset: 0, color: "rgba(255, 251, 189, 0.2)" },
    { offset: 80, color: "rgba(255, 251, 189, 0)" },
  ],
};

export const REPLY_COUNT = {
  id: "replyCount",
  label: "Replies",
  color: "#009ba9",
  static: true, // metric doesn't come with date range data from backend, so no chart is applicable;
  areaColors: [
    { offset: 0, color: "rgba(0, 155, 169, 0.2)" },
    { offset: 80, color: "rgba(0, 155, 169, 0)" },
  ],
};

// LinkedIn Metrics

export const UNIQUE_IMPRESSIONS = {
  id: "unique_impressions",
  label: "Unique Impressions",
  color: "#fffbbd",
  areaColors: [
    { offset: 0, color: "rgba(255, 251, 189, 0.2)" },
    { offset: 80, color: "rgba(255, 251, 189, 0)" },
  ],
};

export const COMMENTS = {
  id: "comments",
  label: "Comments",
  color: "#69d5ff",
  areaColors: [
    { offset: 0, color: "rgba(105, 213, 255, 0.2)" },
    { offset: 80, color: "rgba(105, 213, 255, 0)" },
  ],
};

export const LIKES = {
  id: "likes",
  label: "Likes",
  color: "#009ba9",
  areaColors: [
    { offset: 0, color: "rgba(0, 155, 169, 0.2)" },
    { offset: 80, color: "rgba(0, 155, 169, 0)" },
  ],
};

export const CLICKS = {
  id: "clicks",
  label: "Clicks",
  color: "#85de55",
  areaColors: [
    { offset: 0, color: "rgba(133, 222, 85, 0.2)" },
    { offset: 80, color: "rgba(133, 222, 85, 0)" },
  ],
};

export const ENGAGEMENT = {
  id: "engagement",
  label: "Engagement",
  color: "#7b50ff",
  areaColors: [
    { offset: 0, color: "rgba(123, 80, 255, 0.2)" },
    { offset: 80, color: "rgba(123, 80, 255, 0)" },
  ],
};

export const SHARES = {
  id: "shares",
  label: "Shares",
  color: "#ff5e02",
  areaColors: [
    { offset: 0, color: "rgba(255, 94, 2, 0.2)" },
    { offset: 80, color: "rgba(255, 94, 2, 0)" },
  ],
};

const COMMON_METRICS = [
  POSTS_COUNT,
];

const FACEBOOK_METRICS = [
  ...COMMON_METRICS,
  ENGAGED_USERS,
  POST_REACH,
  PAGE_POST_ENGAGEMENTS,
  POST_IMPRESSION,
  NEW_FAN,
  REACTIONS,
  TOTAL_FANS,
  LINK_CLICKS,
  OTHER_CLICKS,
  PHOTO_VIEW,
  VIDEO_PLAY,
];

const INSTAGRAM_METRICS = [
  ...COMMON_METRICS,
  IMPRESSIONS,
  REACH,
  PROFILE_VIEWS,
  FOLLOWER_COUNT,
  TEXT_MESSAGE_CLICKS,
  WEBSITE_CLICKS,
  EMAIL_CONTACTS,
];

const TWITTER_METRICS = [
  ...COMMON_METRICS,
  RETWEET_COUNT,
  REPLY_COUNT,
  LIKES_COUNT,
  QUOTE_COUNT,
];

const LINKEDIN_METRICS = [
  ...COMMON_METRICS,
  IMPRESSIONS,
  UNIQUE_IMPRESSIONS,
  COMMENTS,
  LIKES,
  CLICKS,
  ENGAGEMENT,
  SHARES,
];

const ALL_METRICS = uniq([
  ...FACEBOOK_METRICS,
  ...INSTAGRAM_METRICS,
  ...TWITTER_METRICS,
  ...LINKEDIN_METRICS,
], "id");

export const getMetricsForSocialType = (socialType) => {
  if (socialType === FACEBOOK_PAGE) {
    return FACEBOOK_METRICS;
  }

  if (socialType === INSTAGRAM_BUSINESS) {
    return INSTAGRAM_METRICS;
  }

  if (socialType === TWITTER_PROFILE) {
    return TWITTER_METRICS;
  }

  if (socialType === LINKEDIN_COMPANY) {
    return LINKEDIN_METRICS;
  }

  return [];
};

export const getAccountMetricById = (id) => {
  return ALL_METRICS.find((metric) => id === metric.id);
};